<template>
  <sk-error-page></sk-error-page>
</template>

<script>
import menu from '@/mixins/menu-mixins'
export default {
  props: [],
  components: {},
  mixins: [menu],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {},
}
</script>
